import React from 'react';
import { connect } from "react-redux";
import "./index.css";

function Billing(props) {
    return (
        <div className="billing-container">
            <div className="sub-head">
                <h2 className="heading">Billing</h2>
            </div>
            <div className="billing-plan-card">
                {props.user.subscriptionId === 1 ?
                    <div className="billing-plan-card-body">
                        <div className="billing-plan-card-details">
                            <div>
                                <p className="plan-name">Enterprise Basic<small className="current">current plan</small></p>
                            </div>
                            <button onClick={() => props.history.push("/subscriptions/manage")} className="manage-plan">Manage</button>
                        </div>
                        <div className="plan-description">
                            <p>Basics of Techforce for Developers</p>
                            <small>Upgrade to Enterprise Editions for managing teams and have one e-worker to manage bots/processes.</small>
                        </div>

                    </div> :
                    <div className="billing-plan-card-body">
                        <div className="billing-plan-card-details">
                            <div>
                                <p className="plan-name">Enterprise Edition<small className="current">current plan</small></p>
                            </div>
                            <button onClick={() => props.history.push("/subscriptions/manage")} className="manage-plan">Manage</button>
                        </div>
                        <div className="plan-description">
                            <p>Basics of Techforce for Small Teams</p>
                            <small>Upgrade to Premium unlimited e-worker to manage bots/processes</small>
                        </div>
                    </div>
                }
            </div>
            {/* <ul className="tabs">
                <li >
                    <label className={activeTab === '1' ? "nav-button active" : "nav-button"}
                       onClick={() => { toggle('1'); }}>Subscriptions</label>
                </li>
                <li>
                    <label className={activeTab === '2' ? "nav-button active" : "nav-button"}
                       onClick={() => { toggle('2'); }}>Payment History</label>
                </li>
            </ul> */}
            {/* <TabContent style={{margin:"10px 0px"}} activeTab={activeTab}>
                <TabPane tabId="1">
                    <div className="billing-plan-card">
                        { props.user.subscriptionId === 1 ?
                            <div className="billing-plan-card-body">
                                <div className="billing-plan-card-details">
                                    <div>
                                        <p className="plan-name">Enterprise Basic<small className="current">current plan</small></p>
                                    </div>
                                    <button onClick={() => props.history.push("/subscriptions/manage")} className="manage-plan">Manage</button>
                                </div>
                                
                            </div> :
                            <div className="billing-plan-card-body">
                                <h5 className="billing-plan-card-title">EmConsole (Start)</h5>
                                <p className="billing-plan-card-text">
                                    Basics of Techforce for small teams
                                </p>
                                <label>Standard Plan | </label>
                                <button onClick={() => props.history.push("/subscriptions/manage")} className="btn ml-2">Manage</button>
                            </div>
                        }
                    </div>
                </TabPane>
                <TabPane tabId="2">
                    <div className="card w-50">
                        <div className="card-body">
                            <p className="card-text">You have not made any payments.</p>
                        </div>
                    </div>
                </TabPane>
            </TabContent> */}
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.user
})

export default connect(mapStateToProps, null)(Billing);
